import React from 'react';

import PropTypes from 'prop-types';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import { Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';

/**
 * This component shows indication that the reference picker activity card is in error state.
 */
const ReferenceActivityCardError = React.forwardRef(
  ({ onTryAgain, ...props }, ref) => {
    const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
    return (
      <ActivityCard ref={ref} {...props}>
        <Flex alignItems="center">
          <AlertWarningIcon />
          <Text typography="bodySmall" color="charcoal700" marginLeft="8px">
            {T.translate('ERROR_LOADING_ACTIVITY')}
          </Text>
          <LinkButton
            style={{ marginLeft: 8 }}
            onClick={onTryAgain}
            size={LinkButton.SIZES.SMALL}
          >
            {T.translate('TRY_AGAIN')}
          </LinkButton>
        </Flex>
      </ActivityCard>
    );
  },
);

ReferenceActivityCardError.displayName = 'ReferenceActivityCardError';

ReferenceActivityCardError.propTypes = {
  ...ActivityCard.propTypes,
  /** Handler for clicking try again */
  onTryAgain: PropTypes.func,
};

export default ReferenceActivityCardError;
